module.exports = __webpack_public_path__ + "static/hero-image-pl-38da6eddb91f40e541b7f0a96ee08bb6.svg";